import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

const configResponseFields = {
  id: true,
  periodType: true,
  fiscalYearStartMonth: true,
  allowStraddleCompletion: true,
  straddleWindowPeriods: true,
  requireStraddleApproval: true,
} as const;

export const createInventoryPeriodConfigAtom = createMutationAtomFactory(
  'inventory.createInventoryPeriodConfig',
  (params: {
    periodType: string;
    fiscalYearStartMonth?: number | null;
    allowStraddleCompletion: boolean;
    straddleWindowPeriods: number;
    requireStraddleApproval: boolean;
  }) => ({
    inventoryInventoryPeriodConfigCreate: {
      __args: {
        input: {
          periodType: params.periodType,
          fiscalYearStartMonth: params.fiscalYearStartMonth,
          allowStraddleCompletion: params.allowStraddleCompletion,
          straddleWindowPeriods: params.straddleWindowPeriods,
          requireStraddleApproval: params.requireStraddleApproval,
        },
      },
      ...configResponseFields,
    },
  }),
);

export const updateInventoryPeriodConfigAtom = createMutationAtomFactory(
  'inventory.updateInventoryPeriodConfig',
  (params: {
    id: string;
    periodType?: string;
    fiscalYearStartMonth?: number | null;
    allowStraddleCompletion?: boolean;
    straddleWindowPeriods?: number;
    requireStraddleApproval?: boolean;
  }) => ({
    inventoryInventoryPeriodConfigUpdate: {
      __args: {
        id: params.id,
        input: {
          periodType: params.periodType,
          fiscalYearStartMonth: params.fiscalYearStartMonth,
          allowStraddleCompletion: params.allowStraddleCompletion,
          straddleWindowPeriods: params.straddleWindowPeriods,
          requireStraddleApproval: params.requireStraddleApproval,
        },
      },
      ...configResponseFields,
    },
  }),
);
